import React from 'react';
import ErrorBoundary from '../Utils/ErrorBoundary/ErrorBoundary';
import LoadingStatus from '../LoadingStatus/LoadingStatus';

const DashboardWidget = ({ statuses, placeHolder, render, widthClasses }) => (
  <div className={`grid-item ${widthClasses}`}>
    <ErrorBoundary>
      <LoadingStatus status={statuses || []} renderLoader={placeHolder}>
        {render}
      </LoadingStatus>
    </ErrorBoundary>
  </div>
);

export default DashboardWidget;
